import React, { Component } from "react";
import { push } from "connected-react-router";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Table } from "components";
import { setBreadcrumb, setLoader, setTitle } from "store/actions";
import { API, Endpoints } from "utils/api";
import { notification } from "antd";
import Strings from "utils/strings";

class Suppliers extends Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			suppliers: []
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(setTitle(""));
		dispatch(setBreadcrumb(null));

		this.getData();
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriSuppliers()
			});

			if (response.ok) {
				this.setState({ suppliers: response.data?.results?.supplier || [] });
			}
		} catch (err) {
			console.log("API Error", err);
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async removeSupplier(id: string) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.delete({
				url: Endpoints.uriSuppliers(id)
			});

			if (response.ok) {
				this.setState({ suppliers: response.data?.results?.supplier || [] });

				notification.success({
					message: Strings.suppliers.supplier,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async toggleSupplier(supplier: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.patch({
				url: Endpoints.uriSuppliers(`${supplier?._id}/status`),
				data: { isActive: !supplier.isActive }
			});

			if (response.ok) {
				this.setState({ suppliers: response.data?.results?.supplier || [] });

				notification.success({
					message: Strings.suppliers.supplier,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { suppliers = [] } = this.state;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.suppliers.suppliers}</title>
					<meta name="description" content="Description of Suppliers" />
				</Helmet>
				<Table
					title={{
						icon: "user-group",
						title: Strings.suppliers.suppliers
					}}
					data={suppliers}
					columns={[
						{
							Header: Strings.fields.name,
							id: "name",
							accessor: (row: any) => row.name || "-"
						},
						{
							Header: Strings.fields.email,
							id: "email",
							accessor: (row: any) => row.email || "-"
						},
						{
							Header: Strings.fields.phone,
							id: "phone",
							accessor: (row: any) => row.phone || "-"
						}
					]}
					filterable
					isSinglePage
					fullPage
					paginated={false}
					add={{
						onClick: () => this.props.dispatch(push("/suppliers/new"))
					}}
					actions={{
						edit: (original: any) => ({
							onClick: () => this.props.dispatch(push(`/suppliers/${original._id}`))
						}),
						remove: (original: any) => ({
							onClick: () => this.removeSupplier(original._id)
						}),
						toggle: (original: any) => ({
							value: original.isActive,
							onChange: () => this.toggleSupplier(original)
						})
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(Suppliers);

